import { z } from "zod";

const catalogCodeSchema = z.string().regex(/^[A-Z][A-Z0-9_]{0,63}$/u);

export const propertyAddressCatalogStateSchema = z.strictObject({
  stateCode: catalogCodeSchema,
  stateName: z.string().min(1),
  countryCode: z.literal("US"),
});
export const propertyAddressCatalogCountySchema = z.strictObject({
  countyCode: catalogCodeSchema,
  countyName: z.string().min(1),
  stateCode: catalogCodeSchema,
});
export const propertyAddressCatalogCitySchema = z.strictObject({
  cityCode: catalogCodeSchema,
  cityName: z.string().min(1),
  countyCode: catalogCodeSchema,
});
export const propertyAddressCatalogPostalCodeSchema = z.strictObject({
  postalCode: z.string().regex(/^\d{5}$/u),
  timezoneRegion: z.string().min(1),
});

const list = <T extends z.ZodType>(item: T) => z.strictObject({ data: z.array(item) });
export const propertyAddressCatalogStatesResponseSchema = list(propertyAddressCatalogStateSchema);
export const propertyAddressCatalogCountiesResponseSchema = list(
  propertyAddressCatalogCountySchema,
);
export const propertyAddressCatalogCitiesResponseSchema = list(propertyAddressCatalogCitySchema);
export const propertyAddressCatalogPostalCodesResponseSchema = list(
  propertyAddressCatalogPostalCodeSchema,
);

export type PropertyAddressCatalogState = z.infer<typeof propertyAddressCatalogStateSchema>;
export type PropertyAddressCatalogCounty = z.infer<typeof propertyAddressCatalogCountySchema>;
export type PropertyAddressCatalogCity = z.infer<typeof propertyAddressCatalogCitySchema>;
export type PropertyAddressCatalogPostalCode = z.infer<
  typeof propertyAddressCatalogPostalCodeSchema
>;
